import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-36359742"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "se-checkbox" }
const _hoisted_2 = ["onclick", "checked"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("input", {
      onclick: _ctx.readonly ? 'return false;' : 'return true',
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      checked: _ctx.checked,
      type: "checkbox",
      style: {"justify-self":"center"}
    }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}